import { Link } from 'react-router-dom';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useDashboardSearchCondition } from '@/providers/DashboardSearchConditionProvider';
import { objectToQueryString } from '@/utils';
import { useEffect, useState } from 'react';

export const CsvExport = () => {
  const { _w_ } = useCurrentWorkspace();
  const { salesOrdersDashboardSearchCondition: searchCondition } = useDashboardSearchCondition();
  const [queryString, setQueryString] = useState<string>('');

  useEffect(() => {
    setQueryString((_) => objectToQueryString({ ...searchCondition, identifier: _w_!.identifier }));
  }, [searchCondition]);

  return (
    <a
      href={`${process.env.REACT_APP_API_URL}/api/workspaces/${
        _w_!.identifier
      }/dashboard/export_csv.csv?${queryString}`}
      className="btn btn-icon btn-dark me-3"
    >
      <i className="fas fa-file-download"></i> エクスポート
    </a>
  );
};
